export const flattenObjectToStringList = (obj: Record<string, any>) => {
    const result: string[] = [];
    Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'string') {
            result.push(obj[key]);
        } else if (typeof obj[key] === 'object') {
            result.push(...flattenObjectToStringList(obj[key]));
        }
    });
    return result;
};

export const sanitizeContent = (html: string) => {
    // Sanitizes HTML content by removing potentially dangerous elements and attributes:
    // 1. Removes all <script> tags and their content
    // 2. Removes all <iframe> tags and their content
    // 3. Removes any javascript: protocol URLs
    // 4. Removes all on* event handlers (onclick, onload, etc.)
    const sanitized = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
        .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
        .replace(/javascript:/gi, '')
        .replace(/on\w+="[^"]*"/gi, '');
    return sanitized;
};
